<template>
  <div>
    <b-row align-h="center" align-v="center">
      <b-col class="col-md-10">
        <b-row class="mt-3">
          <b-col class="text-left">
            <h3 v-if="ocorrencia.id"> Ocorrencia nº {{ ocorrencia.id }}</h3>
            <h3 v-else>Nova Ocorrência</h3>
          </b-col>
          <b-col class="text-right">
            <b-button variant="primary" size="sm" @click="voltar()">
              <i class="fas fa-list"></i> Listar Ocorrências
            </b-button>
          </b-col>
        </b-row>
        <b-card>
          <b-card-header :class="getClass" v-if="ocorrencia.id">
            <b-row>
              <b-col>
                <h4>
                  <p><b>{{ tipoOcorrencia }}</b></p>
                </h4>
              </b-col>
            </b-row>
            <b-row class="mt-2">
              <b-col>
                <p><b> Código da Ocorrência:</b> {{ ocorrencia.id }}</p>
              </b-col>
              <b-col>
                <p><b> Status:</b> {{ getStatus }}</p>
              </b-col>
            </b-row>
            <b-row class="mt-2">
              <b-col cols="9">
                <p><b> Distribuidor: </b> {{ ocorrencia.distribuidor.codigo }} - {{ ocorrencia.distribuidor.nome }} </p>
              </b-col>
              <b-col v-if="ocorrencia.enviar_para">
                <p><b>Enviar Para:</b> {{ ocorrencia.enviar_para }}</p>
              </b-col>
            </b-row>
            <b-row v-if="ocorrencia.revendedora && ocorrencia.revendedora.nome" class="mt-2">
              <b-col>
                <p><b>Revendedora: </b> {{ ocorrencia.revendedora ? ocorrencia.revendedora.nome : '' }} </p>
              </b-col>
            </b-row>
            <b-row class="mt-2">
              <b-col class="col-md-2">
                <p><b>Lote:</b> {{ ocorrencia.lote.codigo }}</p>
              </b-col>
              <b-col class="text-right">
                <p><b> Abertura:</b> {{ formatarData(ocorrencia.created_at) }} </p>
              </b-col>
              <b-col class="text-right">
                <p><b> Última Atualização:</b> {{ formatarData(ocorrencia.updated_at) }}</p>
              </b-col>
            </b-row>
          </b-card-header>
          <b-card-body>
            <v-mensagens :ocorrenciaProps="ocorrencia" class="mt-3"></v-mensagens>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>
<script>
export default {
  data() {
    return {
      ocorrencia: {},
      optionsOc: [],
    }
  },

  computed: {
    getClass() {
      let classe = '';
      switch (this.ocorrencia.status) {
        case 'EM ATENDIMENTO': classe = 'ATENDIMENTO'; break;
        case 'SOLUCIONADO': classe = 'SOLUCIONADO'; break;
        case 'PENDENTE': classe = 'PENDENTE'; break;
        case 'FECHADO': classe = 'FECHADO'; break;
        case 'NOVO': classe = 'NOVO'; break;
      }
      return classe;
    },
    tipoOcorrencia() {
      const vm = this;
      let tipo = "";
      if (vm.optionsOc.length > 0) {
        tipo = vm.optionsOc.find((el) => el.value == vm.ocorrencia.tipo)
      }
      return tipo && tipo.text ? tipo.text : "";
    },
    getStatus() {
      let status = this.ocorrencia.id ? this.ocorrencia.status : 'NOVO';
      return status;
    }
  },
  mounted() {
    if (document.getElementById('ocorrencia').value) {
      this.ocorrencia = JSON.parse(document.getElementById('ocorrencia').value);
    }
    this.getTipoOcorrencias();
  },
  methods: {
    getTipoOcorrencias() {
      const vm = this;
      axios.get('/ocorrencia/get/tipo-ocorrencia')
        .then((response) => {
          response.data.tipos.forEach((el) => {
            vm.optionsOc.push(el);
          })
        }).catch((error) => {
          console.log(error);
        })
    },
    voltar() {
      window.location.href = "/ocorrencia";
    },
    formatarData(data) {
      return moment(data).format('DD/MM/YYYY HH:mm:ss')
    }
  },
}
</script>

<style>
.NOVO {
  background-color: #bdfdbd;
}

/* #ABERTO {
  background-color: #00FFFF;
} */

.SOLUCIONADO {
  background-color: #cfe8ff;
}

.PENDENTE {
  background-color: #fffec5;
}

.FECHADO {
  background-color: #363636;
  color: #f1f9ff;
}

.ATENDIMENTO {
  background-color: #FFE4E1;
}
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/ocorrencia/Edit.vue